import {
  AttributeOptions,
  IngressRequestForm,
  SelectedAttributeDefinitions,
} from '@dispatch/shared/types';
import { SelectField } from '@dispatch/web/ui';
import { Grid } from '@mui/material';
import {
  Control,
  FieldValues,
  UseFieldArrayAppend,
  UseFormWatch,
} from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';

export type IngressClaimAttributesAddProps = {
  append: UseFieldArrayAppend<FieldValues, 'claimAttributes'>;
  control: Control<FieldValues>;
  watch: UseFormWatch<IngressRequestForm>;
  companyAttributes: AttributeOptions[];
  isReview?: boolean;
};

export function IngressClaimAttributesAdd({
  append,
  control,
  watch,
  companyAttributes,
  isReview,
}: IngressClaimAttributesAddProps) {
  const handleAddClaimAttributes = (value: unknown) => {
    const rawValue = value as { title: string; value: string };
    const selectedAttribute = getSelectedAttributeData(rawValue.value);

    append(selectedAttribute);
  };

  const getSelectedAttributeData = (
    integrationGUID: string
  ): SelectedAttributeDefinitions => {
    const selectedAttribute = companyAttributes.find(
      (attribute) => attribute.value === integrationGUID
    );

    return {
      integrationGUID: uuidv4(),
      attributeDefinitionIntegrationGUID: selectedAttribute?.value || '',
      displayName: selectedAttribute?.title || '',
      selectedAttributeValuesVarchars: [],
      selectedAttributeValuesBools: [],
      selectedAttributeValuesInts: [],
      selectedAttributeValuesFloats: [],
    };
  };

  const getFilteredOptions = () => {
    const formAttributes = watch('claimAttributes');

    if (!formAttributes) {
      return companyAttributes;
    }

    const filteredCompanyAttributes = companyAttributes.filter(
      (companyAttribute) => {
        return !formAttributes.find(
          (formAttribute) =>
            formAttribute.attributeDefinitionIntegrationGUID ===
            companyAttribute.value
        );
      }
    );

    return filteredCompanyAttributes.map((value) => ({
      title: value.title,
      value: value.value,
    }));
  };

  return (
    <div
      style={{
        padding: '24px',
      }}
    >
      <Grid container rowSpacing={4} spacing={2}>
        <Grid item xs={6}>
          <SelectField
            id="addSelectedAttributeGUID"
            name="addSelectedAttributeGUID"
            label="Add New Attribute"
            control={control}
            onValueChange={handleAddClaimAttributes}
            options={getFilteredOptions()}
            disabled={isReview}
          />
        </Grid>
      </Grid>
    </div>
  );
}
